"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var polished_1 = require("polished");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  height: 100%;\n  grid-template-columns: 1fr minmax(", ", 40%);\n  grid-template-areas: '. modal';\n"], ["\n  display: grid;\n  height: 100%;\n  grid-template-columns: 1fr minmax(", ", 40%);\n  grid-template-areas: '. modal';\n"])), (0, polished_1.rem)(600));
var templateObject_1;